import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/upload-image.svg'


const _withScopeId = n => (_pushScopeId("data-v-3e8c15be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-4 tw-box-border md:tw-flex-col" }
const _hoisted_2 = { class: "left_upload_img md:!tw-w-full" }
const _hoisted_3 = { class: "upload__area" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Upload images and files.", -1))
const _hoisted_5 = { class: "uploade-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "upload-description" }, " Attachments such as images, design ideas and documents help better understand the project and provide increasingly accurate estimates. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "upload_img__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_8 = {
  key: 1,
  class: "error_msg"
}
const _hoisted_9 = { class: "upload__list tw-w-[calc(100%-390px)] tw-h-[480px] tw-rounded-lg tw-flex tw-justify-center tw-gap-4 tw-box-border md:!tw-w-full md:tw-h-auto" }
const _hoisted_10 = { class: "tw-w-full tw-flex tw-justify-end tw-items-center tw-gap-3 tw-border-t-dashed-custom tw-pt-4 tw-box-border" }

import { computed, onMounted, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import ProjectAttachmentListComponent from "@/modules/project/components/common/ProjectAttachmentListComponent.vue";
import { PROJECT_STORE } from "@/store/modules/project";
import { USER_STORE } from "@/store/modules/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadProjectAttachmentsModal',
  props: {
  loading: {
    type: Boolean,
    default: false,
  },
  isPropertyOwner: {
    type: Boolean,
    default: false,
  },
  projectAttachments: {
    type: Array,
  },
  projectData: {
    type: Object,
    default: null,
  },
},
  emits: ["on-close", "on-success", "on-save"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;

const store = useStore();
const route = useRoute();

const isSaving = ref(false);

const imageUrl = ref("");
const errorMessage = ref("");
const uploadedImages = ref(null) as any;
const attachmentDataList = ref([]) as any;

const state = reactive({
  loading: false,
});

const propertyId = computed(() => route?.params?.propertyId);

const isAttachmentDataValid = computed(() => {
  if (!attachmentDataList.value || attachmentDataList.value.length === 0) {
    return false;
  }

  return attachmentDataList.value.every(
    (attachment: { propertyId: null; userCategoryName: null }) =>
      attachment.propertyId !== null && attachment.userCategoryName !== null
  );
});

const onCloseModal = async () => {
  attachmentDataList.value = attachmentDataList.value.filter(
    (attachment: { userCategoryName: null }) => {
      return attachment.userCategoryName;
    }
  );

  await store.dispatch(
    `${PROJECT_STORE}/setProjectAttachments`,
    attachmentDataList.value
  );

  emits("on-close");
};

const onFileChange = async (event: any) => {
  const fileInput = event.target;
  errorMessage.value = "";
  if (fileInput.files && fileInput.files.length > 0) {
    Array.from(fileInput.files).forEach((file: any) => {
      if (file.type.includes("image")) {
        // Check image size limit (200MB)
        if (file.size <= 200 * 1024 * 1024) {
          imageUrl.value = URL.createObjectURL(file);
          uploadedImages.value = {
            url: imageUrl.value,
            name: file.name,
            imageData: file,
            id: `${file.name}_${Date.now()}`,
          };
          addPropertyImage();
        } else {
          errorMessage.value = "Image size exceeds the limit (200MB).";
          // Handle error message or display notification
        }
      } else if (file.type.includes("video")) {
        // Check video size limit (20MB)
        if (file.size <= 10 * 1024 * 1024) {
          uploadedImages.value = {
            type: "video",
            name: file.name,
            imageData: file,
          };
          addPropertyImage();
          // Process video file
        } else {
          errorMessage.value = "Video size exceeds the limit (20MB).";
          // Handle error message or display notification
        }
      } else {
        // Allow other file types without size validation
        imageUrl.value = URL.createObjectURL(file);
        uploadedImages.value = {
          url: imageUrl.value,
          name: file.name,
          imageData: file,
        };
        addPropertyImage();
      }
    });
  } else {
    console.error("Error: No file selected.");
  }
};
const clearImageUrl = () => {
  selectedFile.value = [];
  imageUrl.value = "";
  errorMessage.value = "";
  uploadedImages.value = null;
};

const addPropertyImage = () => {
  if (uploadedImages.value) {
    attachmentDataList.value.push({
      uploadedImages: { ...uploadedImages.value },
      propertyId: propertyId.value,
      userCategoryName: "Others",
      type: uploadedImages.value?.imageData?.type,
    });
    clearImageUrl();
  }
};

const removeImageFromAttachments = (index: number, attachmentId: number) => {
  // attachmentDataList.value.splice(index, 1);

  if (!props.isPropertyOwner) {
    cloneAttachmentDataList.value.forEach((attachment: any) => {
      if (attachment.uploadedImages.id === attachmentId) {
        attachment["isDeleted"] = true;
      }
    });
  }
  clearImageUrl();
};

const onSave = async () => {
  isSaving.value = true;
  if (props.isPropertyOwner) {
    if (isAttachmentDataValid.value) {
      await store.dispatch(
        `${PROJECT_STORE}/setProjectAttachments`,
        attachmentDataList.value
      );
    }
  } else {
    try {
      //new attachment add functionality
      const newAttachmentDataList = attachmentDataList.value.filter(
        (attachment: any) => attachment?.uploadedImages.imageData
      );
      const filterAttachmentDataList = attachmentDataList.value.filter(
        (attachment: any) => !attachment?.uploadedImages.imageData
      );
      // check if new category add then upload that
      for (const attachment of attachmentDataList.value) {
        const existCategory = availableCategoryList.value.find(
          (category: any) => category.label === attachment.userCategoryName
        );
        if (!existCategory) {
          const response = await store.dispatch(
            `${PROJECT_STORE}/attachmentCategory`,
            {
              label: attachment.userCategoryName,
              value: attachment.userCategoryName,
            }
          );
          availableCategoryList.value.push(response);
        }
      }

      let newCreatedAttachment = [];
      if (newAttachmentDataList.length) {
        const formData = new FormData();
        newAttachmentDataList.forEach((attachment: any) => {
          if (attachment.uploadedImages.imageData) {
            formData.append(`files`, attachment.uploadedImages.imageData);
          }
        });
        const uploadMultipleImage = await store.dispatch(
          `${USER_STORE}/uploadMultipleImage`,
          formData
        );

        newCreatedAttachment = uploadMultipleImage.map(
          (item: any, index: number) => ({
            publicUrl: item.publicUrl,
            attachment: item.attachment,
            originalName: item.originalName,
            propertyIds: [
              {
                propertyId: projectProperty.value?.property?.id,
                isDeleted: false,
              },
            ],
            attachmentCategoryId: availableCategoryList.value.find(
              (category: any) =>
                category.label === newAttachmentDataList[index].userCategoryName
            ).id,
            isDeleted: false,
          })
        );
      }

      const finalDataAttachment = [] as any;
      cloneAttachmentDataList.value.forEach((attachment: any, index: any) => {
        let attachmentData;
        if (attachment.isDeleted) {
          attachmentData = {
            id: attachment?.uploadedImages?.attachmentId,
            attachment: attachment?.uploadedImages?.attachment,
            originalName: attachment?.uploadedImages?.name,
            attachmentCategoryId: attachment?.categoryId,
            propertyIds: [
              {
                id: attachment?.uploadedImages?.id,
                propertyId: projectProperty.value?.property?.id,
                isDeleted: true,
              },
            ],
            isDeleted: attachment.isDeleted,
          };
        } else {
          const propertyIds: any = [
            {
              id: attachment?.uploadedImages?.id,
              propertyId: projectProperty.value?.property?.id,
              isDeleted: false,
            },
          ];

          attachmentData = {
            id: attachment?.uploadedImages?.attachmentId,
            attachment: attachment?.uploadedImages?.attachment,
            originalName: attachment?.uploadedImages?.name,
            attachmentCategoryId: availableCategoryList.value.find(
              (category: any) =>
                category.label ===
                filterAttachmentDataList[index].userCategoryName
            ).id,
            propertyIds: propertyIds,
          };
        }
        finalDataAttachment.push(attachmentData);
      });
      await store.dispatch(`${PROJECT_STORE}/updateHistoricalProject`, {
        projectId: props.projectData?.id,
        data: {
          attachments: [...newCreatedAttachment, ...finalDataAttachment],
        },
      });
    } catch (error) {
      console.log("error", error);
    } finally {
      isSaving.value = false;
    }
  }
  isSaving.value = false;
  onCloseModal();
};
const userCategory = [
  {
    name: "Floorplan",
  },
  {
    name: "Garden",
  },
  {
    name: "Materials",
  },
  {
    name: "Maps",
  },
];
const selectedFile = ref([]);
const cloneAttachmentDataList = ref([]);
const availableCategoryList = ref();
const projectProperty = ref();
const fileInput = ref(null);

const onClickUploadAttachment = () => {
  fileInput.value?.$el?.querySelector('input[type="file"]')?.click();
};
onMounted(async () => {
  attachmentDataList.value = props.projectAttachments;
  if (!props.isPropertyOwner) {
    projectProperty.value = props.projectData
      ? props.projectData?.projectProperties[0]
      : null;

    attachmentDataList.value = attachmentDataList.value.map((data: any) => {
      return {
        ...data,
        propertyId: data[0],
      };
    });

    availableCategoryList.value = await store.dispatch(
      `${PROJECT_STORE}/getProjectCategoryList`,
      props.projectData.id
    );

    cloneAttachmentDataList.value = JSON.parse(
      JSON.stringify(attachmentDataList.value)
    );
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    onOnClose: onCloseModal,
    width: "900px"
  }, {
    body: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_v_file_input, {
                class: _normalizeClass(["upload_file", { 'added-img': imageUrl.value }]),
                label: "Upload",
                ref_key: "fileInput",
                ref: fileInput,
                loading: __props.loading,
                variant: "solo-filled",
                modelValue: selectedFile.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFile).value = $event)),
                onChange: onFileChange,
                "onClick:clear": clearImageUrl,
                multiple: ""
              }, null, 8, ["loading", "modelValue", "class"]),
              _hoisted_7,
              (imageUrl.value)
                ? (_openBlock(), _createBlock(_component_v_img, {
                    key: 0,
                    class: "uploaded-img",
                    width: 200,
                    "aspect-ratio": "16/9",
                    cover: "",
                    src: imageUrl.value
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_icon, { icon: "mdi mdi-file-image-box" }),
              (errorMessage.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errorMessage.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              onClick: onClickUploadAttachment,
              class: "upload__text"
            }, [
              _createVNode(Button, {
                variant: "accent",
                label: attachmentDataList.value.length ? 'ADD ANOTHER' : 'add',
                onClick: onClickUploadAttachment,
                class: "button"
              }, null, 8, ["label"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(ProjectAttachmentListComponent, {
            attachmentList: attachmentDataList.value,
            onOnDelete: removeImageFromAttachments
          }, null, 8, ["attachmentList"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("section", _hoisted_10, [
        _createVNode(Button, {
          class: "!tw-w-auto",
          variant: "secondary",
          disabled: isSaving.value,
          label: "Cancel",
          isActive: true,
          onClick: onCloseModal
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          class: "!tw-w-auto",
          label: "save",
          variant: "accent",
          isLoading: isSaving.value,
          isActive: attachmentDataList.value.length && isAttachmentDataValid.value,
          onClick: onSave
        }, null, 8, ["isLoading", "isActive"])
      ])
    ]),
    _: 1
  }))
}
}

})